<template>
    <div class="animated revealUp">
      <div class="white-wrapper">
        <div class="section-title">
          {{ $t("Consolidated Movie Report") }}
        </div>
        <small><em>{{ $t("* As Per Show Date") }}</em></small>
        <div class="mt-3 mb-2">
          <div class="row">
            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    dropDown.cinemas && dropDown.cinemas.length > 0
                      ? 'shift-up'
                      : ''
                  "
                  >{{ $tc("cinema", 1) }}</label
                >
                <multiselect
                  :disabled="isRoleID"
                  :options="dropDown.cinemas"
                  v-model="dropDown.selectedCinema"
                  :searchable="true"
                  label="cine_name"
                  track-by="cine_id"
                  placeholder="Cinema"
                  @input="onSelectCinema($event)"
                  :allowEmpty="false"
                  :showLabels="false"
                ></multiselect>
              </div>
            </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                      ✖
                    </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                      ✖
                    </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>  
            <div class="col-lg-6 col-xl-2 align-self-center mb-3">
              <button
                class="btn-blue-lg w-100"
                @click.prevent="getMovieWiseData('N', 'N')"
              >
                {{ $t("fetch") }}
              
              </button>
            </div>
  
            <div
              v-if="movieWiseData.length > 0"
              class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
            >
              <div class="mx-1">{{ $t("download") }} as:</div>
              <a
                target="_blank"
                @click="getMovieWiseData('Y', 'N')"
                title="Download as Excel"
                download
                style="cursor: pointer;"
              >
                <img
                  class="mx-1"
                  src="@/assets/img/icons/excel.svg"
                  height="25"
                  width="25"
                />
              </a>
              <a
                target="_blank"
                @click="getMovieWiseData('N', 'Y')"
                title="Download as PDF"
                download
                style="cursor: pointer;"
              >
                <img
                  class="mx-1"
                  src="@/assets/img/icons/pdf.svg"
                  height="25"
                  width="25"
                />
              </a>
            </div>
          </div>
        </div>
  
        <div>
        <div class="table-scroll">
          <table class="swc-report-table swc_table_header" border="1" v-if="movieWiseData.length > 0">
  <thead class="bg-lightgrey">
    <tr>
      <th>Movie</th>
      <th>Footfall</th>
      <th>Occupancy %</th>
      <th>Net Revenue</th>
      <th>Gross Revenue</th>
    </tr>
  </thead>
    <template v-for="(movieData, DataIndex) in movieWiseData">
      <tr class="distName" style="background-color: rgb(232,232,232)">
        <th class="text-left" colspan="5">{{ movieData.movieName }}</th>
      </tr>
      <template v-for="(saledata, index) in movieData.data">
        <tr>
          <td class="text-left">{{ saledata.movie_format }}</td>
          <td class="text-right">
            {{ saledata.records.reduce((sum, rec) => sum + rec.admits, 0) }}
          </td>
          <td class="text-right">
            {{
              currFormat(
                (saledata.records.reduce((sum, rec) => sum + rec.admits, 0) /
                saledata.records.reduce((sum, rec) => sum + rec.available_capacity, 0)) * 100
              )
            }}%
          </td>
          <td class="text-right">
            {{ currFormat(saledata.records.reduce((sum, rec) => sum + rec.vat, 0)) }}
          </td>
          <td class="text-right">
            {{ currFormat(saledata.records.reduce((sum, rec) => sum + rec.bor, 0)) }}
          </td>
        </tr>
      </template>
      <tr style="background-color: rgb(225,225,225)" class="font-weight-bold">
        <td class="text-left font-weight-bold">Total</td>
        <td class="text-right">
          {{
            movieData.data.reduce((total, saledata) => 
              total + saledata.records.reduce((sum, rec) => sum + rec.admits, 0), 0)
          }}
        </td>
        <td class="text-right">
          {{
            currFormat(
              (movieData.data.reduce((totalAdmits, saledata) =>
                totalAdmits + saledata.records.reduce((sum, rec) => sum + rec.admits, 0), 0) /
              movieData.data.reduce((totalCapacity, saledata) =>
                totalCapacity + saledata.records.reduce((sum, rec) => sum + rec.available_capacity, 0), 0)) * 100
            )
          }}%
        </td>
        <td class="text-right">
          {{
            currFormat(
              movieData.data.reduce((total, saledata) => 
                total + saledata.records.reduce((sum, rec) => sum + rec.vat, 0), 0)
            )
          }}
        </td>
        <td class="text-right">
          {{
            currFormat(
              movieData.data.reduce((total, saledata) => 
                total + saledata.records.reduce((sum, rec) => sum + rec.bor, 0), 0)
            )
          }}
        </td>
      </tr>
    </template>
    <thead class="bg-lightgrey">
              <tr>
                <th class="text-left">Grand Total</th>
                <th class="text-right">
                  {{ grandTotal.admits || 0 }}
                </th>
                <th class="text-right">
                  {{
                    currFormat((grandTotal.admits / grandTotal.available_capacity) * 100)
                  }}
                </th>
                <th class="text-right">
                  {{ currFormat(grandTotal.vat || 0) }}
                </th>
                <th class="text-right">{{ currFormat(grandTotal.bor || 0) }}</th>
              </tr>
            </thead>
</table>
        </div>
      </div>

      </div>
    </div>
  </template>
  <script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/NewReportService";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import xlsx from "json-as-xlsx";
  import VueHtml2pdf from "vue-html2pdf";
  import * as XLSX from "xlsx";
  
  export default {
    components: {
      NoRecords,
      VueHtml2pdf,
    },
    data() {
      return {
        BASEURL,
        isRoleID: false,
        submitted: false,
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        selectedCinema:[],
        fromDate: new Date(),
        toDate: new Date(),
        movieWiseData: [],
  
        excelFilePath: "",
        grandTotal: {},
        selectedMovieName: [],
        allMovieNames: [],
      };
    },
    beforeMount() {
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      const { cinema_id } = this.secureStore.get("USINFO");
      this.getCinemaList(cinema_id)
    },
    watch: {
      excelFilePath(value) {
        this.excelFilePath = value;
      },
    },
    mounted() {},
    methods: {
      onChangeDate(e, type){
      if(type == 'from'){
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
      moment,
      getCinemaList: function (cinema_id) {
        MasterService.GetCinemas({cine_id: cinema_id})
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              if(cinema_id) {
                this.dropDown.cinemas = [ ...data.Records];
              } else {
                this.dropDown.cinemas = [ {cine_id : 0, cine_name: "All Cinema"}, ...data.Records];
              }
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectCinema: function (event) {
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = event.cine_id;
        this.$store.dispatch("selectDropdownCinema", event);
      },
      getMovieWiseData(isExcel = "N", isPdf = "N") {
        this.movieWiseData = [];
        if (!this.dropDown.selectedCinema) {
        return this.$toasted.show("Select Cinema");
      }
        if (!this.fromDate) {
          return this.$toasted.show("Select From Date");
        }
        let loader = this.$loading.show();

        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName || "",
          cinema_address: this.dropDown.selectedCinema.cine_address || "",
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          isExcel,
          isPdf,
        };
        ReportsService.getMovieSummaryReport(payload)
          .then((response) => {
            const { data } = response;
          if (!data.status) return this.$toasted.show(data.message);
              this.movieWiseData = [...data.Records];
              this.grandTotal = data.grandTotal;
              if (isExcel == "Y" && data.excelPath) {
                window.open(data.excelPath, "_blank");
              }
              if (isPdf == "Y" && data.pdfPath) {
                window.open(data.pdfPath, "_blank");
              }
              this.$toasted.show(data.message);        
            loader.hide();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
    },
  };
  </script>
  
  <style>
  .concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
  }
  
  .concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
  }
  
  .concession-analysis-table thead th {
    
    border: 1px solid #000;
  }
  
  .concession-analysis-table tbody {
    border-bottom: 1px solid #000;
  }
  
  .concession-analysis-table tbody td {
   
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
  }
  
  .concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
  }
 
  
  .swc-report-table {
    table-layout: auto !important;
    overflow-x: scroll !important;
    border: 1px solid gray;
  }
  .swc-report-table td {
    white-space: nowrap;
  }
  .swc-report-table th {
    white-space: nowrap !important;
    border: 1px solid gray !important;
  }
  .swc_table_header th {
    border: 1px solid gray !important;
  }
  .no_border {
    border: 0px !important;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/movieSummaryReport.vue